import { useContext, useMemo } from 'react'
import { WidthContext } from './WidthContext'

// see sizes.scss
const BRAIKPOINTS = {
  xs: 0,
  sm: 600,
  md: 767,
  lg: 1279,
  xl: 1440,
}

/**
 *
 * @return {{size: 'xs'|'sm'|'md'|'lg'|'xl', width: number, isMobile: boolean, isDesktop: boolean}}
 */
export const useWidth = () => {
  const width = useContext(WidthContext)

  const size = useMemo(() => {
    let size = 'xs'
    for (let key in BRAIKPOINTS) {
      if (width > BRAIKPOINTS[key]) {
        size = key
      }
    }
    return size
  }, [width])

  const isMobile = useMemo(() => size === 'xs' || size === 'sm', [size])
  const isDesktop = useMemo(() => size === 'lg' || size === 'xl', [size])

  return { width, size, isMobile, isDesktop }
}
